import { motion } from 'framer-motion'

export function HeroGlowBackground() {
  return (
    <div aria-hidden className="absolute inset-0 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,_rgba(7,244,242,0.12),_transparent_35%),radial-gradient(circle_at_bottom_right,_rgba(193,250,184,0.12),_transparent_30%),linear-gradient(180deg,_#050505_0%,_#050505_55%,_#000000_100%)]" />
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.04)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.04)_1px,transparent_1px)] bg-[size:48px_48px] opacity-[0.035]" />

      <motion.div
        className="absolute -left-24 top-24 h-72 w-72 rounded-full bg-[#07F4F2]/18 blur-3xl"
        animate={{ x: [0, 36, -12, 0], y: [0, 18, -24, 0] }}
        transition={{ duration: 18, repeat: Infinity, ease: 'easeInOut' }}
      />
      <motion.div
        className="absolute right-[-6rem] top-1/3 h-96 w-96 rounded-full bg-[#C1FAB8]/16 blur-3xl"
        animate={{ x: [0, -42, 16, 0], y: [0, -24, 12, 0] }}
        transition={{ duration: 22, repeat: Infinity, ease: 'easeInOut' }}
      />
      <motion.div
        className="absolute bottom-[-5rem] left-1/2 h-80 w-80 -translate-x-1/2 rounded-full bg-[#07F4F2]/10 blur-3xl"
        animate={{ scale: [1, 1.08, 0.96, 1] }}
        transition={{ duration: 16, repeat: Infinity, ease: 'easeInOut' }}
      />

      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/10 to-black" />
    </div>
  )
}
